import { createSlice } from '@reduxjs/toolkit';
import { Log, LogPagination } from '../Model/Log';
import { 
  fetchLogs, 
  fetchTodayLogs, 
  fetchYesterdayLogs, 
  fetchThisMonthLogs, 
  fetchCustomRangeLogs,
  deleteLog,
  bulkDeleteLogs
} from './actions';

interface State {
  list: Log[];
  pagination?: LogPagination;
  loading: boolean;
  error?: string;
}

const initialState: State = { list: [], loading: false };

const setPending = (state: State) => {
  state.loading = true;
  state.error = undefined;
};

const setFulfilled = (
  state: State,
  payload: { results: Log[]; pagination?: LogPagination }
) => {
  state.list = payload.results;
  state.pagination = payload.pagination;
  state.loading = false;
};

const setRejected = (state: State, error?: string) => {
  state.loading = false;
  state.error = error;
};

const slice = createSlice({
  name: 'log',
  initialState,
  reducers: {},
  extraReducers: b => {
    // 기본 로그 조회
    b.addCase(fetchLogs.pending, setPending)
     .addCase(fetchLogs.fulfilled, (s, a) => { setFulfilled(s, a.payload); })
     .addCase(fetchLogs.rejected, (s, a) => { setRejected(s, a.error.message); })
     
     // 오늘 로그
     .addCase(fetchTodayLogs.pending, setPending)
     .addCase(fetchTodayLogs.fulfilled, (s, a) => { setFulfilled(s, a.payload); })
     .addCase(fetchTodayLogs.rejected, (s, a) => { setRejected(s, a.error.message); })
     
     // 어제 로그
     .addCase(fetchYesterdayLogs.pending, setPending)
     .addCase(fetchYesterdayLogs.fulfilled, (s, a) => { setFulfilled(s, a.payload); })
     .addCase(fetchYesterdayLogs.rejected, (s, a) => { setRejected(s, a.error.message); })
     
     // 이번달 로그
     .addCase(fetchThisMonthLogs.pending, setPending)
     .addCase(fetchThisMonthLogs.fulfilled, (s, a) => { setFulfilled(s, a.payload); })
     .addCase(fetchThisMonthLogs.rejected, (s, a) => { setRejected(s, a.error.message); })
     
     // 기간별 로그
     .addCase(fetchCustomRangeLogs.pending, setPending)
     .addCase(fetchCustomRangeLogs.fulfilled, (s, a) => { setFulfilled(s, a.payload); })
     .addCase(fetchCustomRangeLogs.rejected, (s, a) => { setRejected(s, a.error.message); })
     
     // 로그 삭제
     .addCase(deleteLog.pending, setPending)
     .addCase(deleteLog.fulfilled, s => { s.loading = false; })
     .addCase(deleteLog.rejected, (s, a) => { setRejected(s, a.error.message); })

     // 로그 일괄 삭제
     .addCase(bulkDeleteLogs.pending, setPending)
     .addCase(bulkDeleteLogs.fulfilled, s => { s.loading = false; })
     .addCase(bulkDeleteLogs.rejected, (s, a) => { setRejected(s, a.error.message); });
  },
});
export default slice.reducer;
